module.exports = __webpack_public_path__ + "static/media/portfolio-computer.2f71df8f.webp";